import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';
import { VisitorLeaveSummaryComponent } from './component/visitor-leave-summary.component';



@NgModule({
  declarations: [
    VisitorLeaveSummaryComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ]
})
export class VisitorLeaveSummaryModule { }
